import { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";
import { cashiLogo } from "../../include/cashiBrand";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";

export default function SpinClaim() {
  const { claimId } = useParams();
  const [claim, setClaim] = useState(null);
  const [missing, setMissing] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let mounted = true;
    callPostApi("spin-claim", { mod: "SPIN_CLAIM_OPEN", data_arr: { claim_id: claimId } }).then((result) => {
      if (!mounted) return;
      if (result.status === "200") {
        const row = result.data?.claim;
        setClaim(row);
        if (row?.saved) setDone(true);
      } else setMissing(true);
    });
    return () => { mounted = false; };
  }, [claimId]);

  const save = async () => {
    setSaving(true);
    try {
      const result = await callPostApi("spin-claim", {
        mod: "SPIN_CLAIM_SAVE",
        data_arr: { claim_id: claimId, customer_name: name, customer_mobile: mobile, customer_email: email },
      });
      if (result.status === "200") {
        setDone(true);
        setClaim((prev) => ({ ...prev, customer_name: name.trim(), saved: true }));
        toast.success(result.data?.message || "Saved");
      } else toast.error(result?.status_message || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", background: "linear-gradient(160deg, #21a7ec 0%, #7c3aed 55%, #ec4899 100%)", display: "flex", justifyContent: "center", px: 2, py: 4 }}>
      <Box sx={{ width: "min(440px, 100%)", background: "#fff", borderRadius: 3, p: { xs: 2.5, sm: 3.5 }, alignSelf: "flex-start" }}>
        <Box sx={{ background: "#0a0a0a", borderRadius: 2, px: 1.5, py: 1, mb: 2, display: "flex", justifyContent: "center" }}>
          <Box component="img" src={cashiLogo} alt="Cashi" sx={{ height: 28, width: "auto" }} />
        </Box>
        {missing && <Typography>This prize link is not valid.</Typography>}
        {!claim && !missing && <Typography sx={{ color: consoleColors.muted }}>Loading...</Typography>}
        {claim && (
          <>
            <Typography sx={{ textAlign: "center", color: consoleColors.muted, fontSize: 14 }}>{claim.store_name}</Typography>
            <Typography sx={{ textAlign: "center", fontSize: 15, mt: 1 }}>{claim.headline}</Typography>
            <Typography sx={{ textAlign: "center", fontSize: 13, color: consoleColors.muted, mt: 2 }}>You won</Typography>
            <Typography sx={{ textAlign: "center", fontSize: 30, fontWeight: 800, color: "#15803d" }}>{claim.prize_title}</Typography>
            {done ? (
              <Box sx={{ mt: 2, textAlign: "center" }}>
                <Typography sx={{ fontWeight: 750 }}>Saved</Typography>
                <Typography sx={{ color: consoleColors.muted, mt: 0.5 }}>Show this screen to the store so they can give the prize.</Typography>
                {claim.customer_name && <Typography sx={{ mt: 1, fontWeight: 700 }}>{claim.customer_name}</Typography>}
              </Box>
            ) : (
              <Box sx={{ display: "grid", gap: 1.4, mt: 2.5 }}>
                <TextField label="Name" value={name} onChange={(event) => setName(event.target.value)} />
                <TextField label="Mobile" value={mobile} onChange={(event) => setMobile(event.target.value)} />
                <TextField label="Email" value={email} onChange={(event) => setEmail(event.target.value)} helperText="Optional" />
                <Button variant="contained" sx={primaryButtonSx} disabled={saving} onClick={save}>{saving ? "Saving..." : "Save"}</Button>
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
